import { deepMerge } from '@empathybroker/deep-merge';
import { ConfigState, FacetConfig, FacetsConfig, FacetsGroupConfig, NamedFacetsConfig } from '../../../models';
import { DeepPartial, Dictionary } from '../../../utils';
import { CONFIG_GETTERS_KEYS } from '../../config/config.const';
import { ConfigGetter } from '../config.interfaces';

export class FacetsGroupsGetter implements ConfigGetter {
  getters = {
    /*
     This getter returns the final config of the facets groups
     */
    [CONFIG_GETTERS_KEYS.facetsGroups]: (configState: ConfigState, getters: any): Dictionary<FacetsGroupConfig> => {
      const facetsConfig: FacetsConfig = getters[CONFIG_GETTERS_KEYS.config].facets;
      return Object.entries(facetsConfig.groups)
        .reduce(this.mergeGroupsConfigWithDefaults(facetsConfig, getters), {});
    }
  };

  private mergeGroupsConfigWithDefaults(facetsConfig: FacetsConfig, getters: any) {
    const defaultGroupConfig = facetsConfig.default.group;
    const defaultFacetConfig = facetsConfig.default.facet;
    const namedFacetsConfig: NamedFacetsConfig = getters[CONFIG_GETTERS_KEYS.facets];
    return (facetsGroupConfigs: Dictionary<FacetsGroupConfig>, [groupId, groupConfig]: [string, DeepPartial<FacetsGroupConfig>]) => {
      const groupConfigWithDefaults: FacetsGroupConfig = deepMerge({}, defaultGroupConfig, groupConfig);
      groupConfigWithDefaults.facets = Object.entries(groupConfigWithDefaults.facets)
        .reduce(this.mergeFacetConfigWithDefaults(namedFacetsConfig, defaultFacetConfig), {});
      facetsGroupConfigs[groupId] = groupConfigWithDefaults;
      return facetsGroupConfigs;
    };
  }

  private mergeFacetConfigWithDefaults(namedFacetsConfig: NamedFacetsConfig, defaultFacetConfig: FacetConfig) {
    return (facets: NamedFacetsConfig, [facetName, facetConfig]: [string, DeepPartial<FacetConfig>]) => {
      facets[facetName] = deepMerge({}, namedFacetsConfig[facetName] ?? defaultFacetConfig, facetConfig);
      return facets;
    };
  }
}
